<template>
  <div>
    <van-row>
      <van-col style="padding: 10px"
      ><van-tag type="primary" class="title"></van-tag><strong>{{date}}医院价格策略销售分析</strong></van-col>
    </van-row>
    <van-row style="background: rgb(230,237,255);padding: 15px;color: rgb(128,160,246)">
      <van-col span="6">价格策略</van-col>
      <van-col span="6">销售金额</van-col>
      <van-col span="6">销售占比</van-col>
      <van-col span="6">毛利率</van-col>
    </van-row>

    <template v-for="(item,index) in list">
      <van-row style="margin: 15px">
        <van-col span="6">
          <van-tag type="primary" class="tag" :color="color[index]"></van-tag>
          <strong>{{ item.name }}</strong></van-col>
        <van-col span="6"><strong>{{ item.priceSum | moneyP }}</strong></van-col>
        <van-col span="6"><strong>{{ item.rate }}</strong></van-col>
        <van-col span="6"><strong>{{ item.grossProfitRate }}</strong></van-col>
      </van-row>

    </template>
  </div>

</template>

<script>
import {spdLogistics} from "@/axios/api";
import moment from 'moment'; //导入模块
export default {
  name: "priceStrategy",

  created() {
    spdLogistics.getPriceStrategy(moment().format('YYYY-MM')).then(res => {
      if (res.code === 200) {
        this.list = res.result[0];
        this.date = res.result[1];
      }
    })
  },
  data() {
    return {
      list: [],
      //标签颜色
      color: [
        'rgb(71,122,255)',
        'rgb(90,200,242)',
        'rgb(255,166,70)',
        'rgb(74,237,128)',
        'rgb(147,130,251)'
      ]
    }
  },
  methods: {}
}
</script>

<style scoped>
.tag {
  font-size: 15px;
  margin: 2px;
}
.title{
  transform: rotate(90deg);
  font-size: 15px;
  margin-bottom: 2px;
}

</style>



// WEBPACK FOOTER //
// src/spd/logistics/price-strategy.vue